

type DisableRuleProps = { currentMatchId: string, clean: () => void}
export const DisableRule = ({ currentMatchId, clean } : DisableRuleProps) => {
    return (<button
        key={`${currentMatchId}-clean`}
        className="match-popup-action match-popup-no-error"
        onClick={() => { 
            clean()
        }}
     >Crec que no hi ha error</button>
    )
}